import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { StatusService } from '../../shared/services/status.service';
import { AlertService } from '../../shared/services/alert.service';
import { BusyService } from '../../shared/services/busy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FileUploadService } from '../../shared/core/file-upload.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Status } from '../../shared/models/Status';
import { User } from '../../shared/models/User';
import { AuthService } from '../../shared/services/auth.service';
import { UserFriendlyErrorService } from '../../shared/services/user-friendly-error.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  model: any = {};
  form: FormGroup;
  busy = false;
  busyVoiceRecorder = false;
  user: User;

  constructor(
    private statusService: StatusService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private userFriendlyErrorService: UserFriendlyErrorService,
    private fileUploadService: FileUploadService,
    private cd: ChangeDetectorRef
  ) {
    this.user = AuthService.currentUser();

    this.form = new FormGroup({
      statusDescription: new FormControl('', [Validators.required])
    });

    this.busyService.initHandler('statusCmp', busy => {
      this.busy = busy;
    });

    this.busyService.initHandler('statusCmpVoiceRecorder', busy => {
      this.busyVoiceRecorder = busy;
    });
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      if (p['statusId'] > -1) {
        this.busyService
          .follow('statusCmp', this.statusService.get(p['statusId']))
          .subscribe(status => {
            this.model = status;
          });
      } else {
        this.model.statusId = -1;
      }
    });
  }

  getSoundUrl() {
    if (this.model.soundFile) {
      return (
        environment.api.baseUrl +
        environment.api.status.play
          .toString()
          .replace('{filename}', this.model.soundFile) +
        (this.model.soundFile.toString().indexOf('?') > 0
          ? '&access_token='
          : '?access_token=') +
        encodeURIComponent(this.user.token)
      );
    }
    return null;
  }

  onSendSound(sound) {
    const url =
      environment.api.baseUrl +
      environment.api.status.upload.replace('{statusId}', this.model.statusId);

    if (sound.RecorderFlash) {
      this.busyService.busy('statusCmpVoiceRecorder');
      sound.RecorderFlash.upload({
        method: 'POST',
        url:
          url +
          '?access_token=' +
          encodeURIComponent(AuthService.currentUser().token),
        success: response => {
          this.model.soundFile =
            JSON.parse(response).soundFile + '?t=' + Date.now();
          this.busyService.alive('statusCmpVoiceRecorder');
          this.cd.detectChanges();
        }
      });
    } else {
      const files = [];
      const audioFile = <any>new Blob([sound.blob], { type: 'audio/wav' });
      audioFile.name = this.model.statusId.toString() + '.wav';
      files.push(<File>audioFile);

      this.busyService.busy('statusCmpVoiceRecorder');
      this.fileUploadService
        .upload(url, files)
        .then(r => {
          this.model.soundFile = r.soundFile + '?t=' + Date.now();
          this.busyService.alive('statusCmpVoiceRecorder');
        })
        .catch(error => {
          this.alertService.showError(
            this.userFriendlyErrorService.getErrorMessage(url)
          );

          this.busyService.alive('statusCmpVoiceRecorder');
        });
    }
  }

  cancel() {
    this.router.navigateByUrl('statsound');
  }

  save() {
    if (!this.form.valid) {
      for (const c in this.form.controls) {
        if (!c) {
          continue;
        }
        const control = this.form.controls[c];
        control.markAsDirty();
      }
      return;
    }

    this.busyService
      .follow('statusCmp', this.statusService.save(new Status(this.model)))
      .subscribe(result => {
        if (this.model.statusId > -1) {
          this.alertService.showSuccess('The status was updated successfully.');
        } else {
          this.alertService.showSuccess('The status was added successfully.');
        }

        this.model.statusId = result.statusId;
        this.router.navigateByUrl('statedit/' + this.model.statusId);
      });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/status/status.component.ts